// extracted by mini-css-extract-plugin
module.exports = {"password":"style-module--password--2WcMj","changePass":"style-module--changePass--211CX","subscribe":"style-module--subscribe--3SS1r"};